import { useAPI } from "@/hooks/useAPI";
import { addCaseAnalystToCache, removeCaseAnalystFromCache } from "@/hooks/useCases";
import type { CaseUser } from "@/services/caseServiceV2.types";
import { CaseUsersService } from "@/services/caseUsersService";
import { useCallback, useMemo } from "react";

export const useCaseAnalysts = (caseId: string) => {
  const api = useAPI("v1");
  const caseUsersService = useMemo(() => new CaseUsersService(api), [api]);

  const addAnalyst = useCallback(
    async (analyst: CaseUser): Promise<void> => {
      await caseUsersService.addAnalyst(caseId, analyst.user_id);
      addCaseAnalystToCache(caseId, analyst);
    },
    [caseUsersService, caseId]
  );

  const removeAnalyst = useCallback(
    async (userId: string): Promise<void> => {
      await caseUsersService.removeAnalyst(caseId, userId);
      removeCaseAnalystFromCache(caseId, userId);
    },
    [caseUsersService, caseId]
  );

  return { addAnalyst, removeAnalyst };
};
